import React, { useState } from "react";
import "./Speculation.css";
import Slider from "./Slider";
import SpecChart from "./SpecChart";
import SpecMap from "./SpecMap";

const Speculation: React.FC = () => {
  const [sliderVal, setSliderVal] = useState(2000);

  return (
    <div className="spec">
        <span>
          <strong>Percent of Properties Flipped in Boston by Year </strong>
        </span>
      <div className="spec-vis-h">
        <SpecChart sliderVal={sliderVal} />
        <SpecMap sliderVal={sliderVal} />
      </div>
      <Slider min={2000} max={2022} value={2000} onChange={setSliderVal} />
    </div>
  );
};

export default Speculation;
